var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { config } from "@frameworks/salesjourney/config/domain";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
var ReportsByCategory = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = __read(useState(false), 2), openAcc = _f[0], setOpenAcc = _f[1];
    var handleClick = function (report) {
        if (report.id === 64) {
            return (config.applicationFolder +
                "dashboard/rm-partners-reports/zerosing-report/" +
                btoa("".concat(report === null || report === void 0 ? void 0 : report.name)) +
                "/" +
                btoa("".concat(report === null || report === void 0 ? void 0 : report.id)));
        }
        return (config.applicationFolder +
            "dashboard/rm-partners-reports/" +
            btoa("".concat(report === null || report === void 0 ? void 0 : report.name)) +
            "/" +
            btoa("".concat(report === null || report === void 0 ? void 0 : report.id)));
    };
    return (React.createElement(Accordion.Item, { eventKey: props === null || props === void 0 ? void 0 : props.reportsByCategory.groupName, onBlur: function () {
            setOpenAcc(false);
        }, onClick: function (e) {
            setOpenAcc(!openAcc);
        }, className: openAcc ? "active-accordion" : "" },
        React.createElement(Accordion.Header, { className: "DMSan_14_500 txt-midnight-blue" },
            (props === null || props === void 0 ? void 0 : props.reportsByCategory.groupName) !== "Search Result" && (React.createElement("span", { className: "toggle-arrow-icon" },
                React.createElement("i", { className: openAcc ? "edel-icon-arrow-up" : "edel-icon-arrow-down", onClick: function () {
                        setOpenAcc(!openAcc);
                    } }))),
            React.createElement("span", null, (_a = props === null || props === void 0 ? void 0 : props.reportsByCategory) === null || _a === void 0 ? void 0 : _a.groupName)),
        React.createElement(Accordion.Body, null,
            React.createElement("div", { className: "single-category-reports" }, ((_c = (_b = props === null || props === void 0 ? void 0 : props.reportsByCategory) === null || _b === void 0 ? void 0 : _b.subReportGroupList) === null || _c === void 0 ? void 0 : _c.length) > 0 ? ((_e = (_d = props === null || props === void 0 ? void 0 : props.reportsByCategory) === null || _d === void 0 ? void 0 : _d.subReportGroupList) === null || _e === void 0 ? void 0 : _e.map(function (report) { return (React.createElement("div", { className: "one-report" },
                React.createElement("span", { className: "DMSan_14_500 cursor-pointer" },
                    React.createElement("a", { className: "txt-midnight-blue", href: handleClick(report) },
                        React.createElement("u", null, report === null || report === void 0 ? void 0 : report.name))))); })) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION }))))));
};
export default ReportsByCategory;
